export enum ProcedureEnum {
	StudyModel_iRecord = 1,
	Invisalign = 2,
	ImplantPlanning = 3,
	FixedRestorative = 4,
	Denture_Removable = 5,
	Appliance = 6,
	InvisalignART = 7,
}
